package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class OwnerDto(
    val uid: String,
    val businessName: String,
    val subscriptionStatus: String,
    val workplaceIds: List<String> = emptyList(),
    /** ISO 8601; written only by functions/planAccess.js (firestore.rules). */
    val trialStartedAt: String? = null
)